import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  appPage: {
    background: "#f6fbfa"
  },
  appPageHeader: {
    height: "initial",
    zIndex: 1231
  }
});
